const successMessageKey = "Notification_._Success Message_._Successful";
const errorMessageKey = "Notification_._Error Message_._Something went wrong";
const noNotification = "noNotification";
var UserNotificationRenderType = /* @__PURE__ */ ((UserNotificationRenderType2) => {
  UserNotificationRenderType2[UserNotificationRenderType2["Modal"] = 0] = "Modal";
  UserNotificationRenderType2[UserNotificationRenderType2["Snackbar"] = 1] = "Snackbar";
  return UserNotificationRenderType2;
})(UserNotificationRenderType || {});
var UserNotificationType = /* @__PURE__ */ ((UserNotificationType2) => {
  UserNotificationType2["Success"] = "success";
  UserNotificationType2["Fail"] = "fail";
  UserNotificationType2["Notice"] = "notice";
  UserNotificationType2["NoticeIp"] = "noticeIp";
  UserNotificationType2["FailSecond"] = "failSecond";
  return UserNotificationType2;
})(UserNotificationType || {});
export {
  UserNotificationRenderType,
  UserNotificationType,
  errorMessageKey,
  noNotification,
  successMessageKey
};
